<template>
    <div> 
        <p class="text-white">
            Selecciona a donde quieres retirar el dinero
        </p>
        <div class="flex flex-col pb-4 form-group">
            <div>
                <label for="destination_account_category_bank" class="edit-profile_form_label">
                <input type="radio" id="destination_account_category_bank" name="destination_account[category]" value="arcadi_account" checked />
                    Cuenta arcadi
                </label>
            </div>
            <div>
                <input type="radio" id="destination_account_category_wallet" name="destination_account[category]" value="ledger_account" />
                <label for="destination_account_category_wallet" class="edit-profile_form_label">
                    Cuenta tarjeta
                </label>
            </div>
        </div>
        <div class="flex flex-col w-full gap-4">
            <!-- TODO: poner un input tipo "simulator" con el selector de paises y el monto -->
            <input type="number" v-model="amount" class="flex flex-col px-2 py-4 mb-3 balance-container border-container-balance" />
            <div class="grid justify-items-center center-img w-full">
                <a
                    class="cursor-pointer w-full mt-0 text-white shadow-md arcadi-form__submit dashboard-tab-button-primary"
                    style="height: 50px;"
                >
                    Realizar abono
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                amount: 0
            }
        }
    }
</script>